import { Button, TitleBar } from "modules/common";
import { IProfileAlarmsProps } from "modules/common/components/Alarms/types/IProfileAlarmsProps";
import { ReactComponent as EditIcon } from "assets/icons/pencil.svg";
import { ReactComponent as DeleteIcon } from "assets/icons/delete.svg";
import { useContext } from "react";
import { AccessibilityContext } from "views/AccessibilityContext";

export const ProfileAlarms: React.FC<IProfileAlarmsProps> = ({
    savedAlarms,
    openCreateAlarmGroupModal,
    openUpdateAlarmGroupModal,
    openDeleteAlarmGroupModal,
}) => {
    const { fontSize, lowVision } = useContext(AccessibilityContext);
    return (
        <div className="profile-alarms">
            <TitleBar>
                <TitleBar.Left>
                    <span
                        className="title-bar-text profile-title"
                        style={{ fontSize: `${fontSize}%` }}
                    >
                        Grupe alarma
                    </span>
                </TitleBar.Left>
            </TitleBar>

            <div className="profile-alarms-content">
                <div className="profile-alarms-row">
                    <span className="profile-alarms-subtitle">Spremljene grupe alarma</span>
                    <Button
                        type="button"
                        variant="primary"
                        lowVision={lowVision}
                        size="small"
                        onClick={openCreateAlarmGroupModal}
                    >
                        Kreiraj grupu alarma
                    </Button>
                </div>

                <div className="profile-alarms-list">
                    {savedAlarms?.length
                        ? savedAlarms?.map(alarmGroup => (
                              <div key={alarmGroup.id} className="profile-alarms-row">
                                  <span>{alarmGroup.name}</span>
                                  <div className="profile-alarms-row-actions">
                                      <Button
                                          type="button"
                                          size="small"
                                          isIcon
                                          onClick={() => openUpdateAlarmGroupModal(alarmGroup)}
                                      >
                                          <EditIcon />
                                      </Button>
                                      <DeleteIcon
                                          className="profile-alarms-row-delete-action"
                                          onClick={() => openDeleteAlarmGroupModal(alarmGroup)}
                                      />
                                  </div>
                              </div>
                          ))
                        : null}
                </div>
            </div>
        </div>
    );
};
